import { render, staticRenderFns } from "./FormCheckboxInput.vue?vue&type=template&id=59225520"
import script from "./FormCheckboxInput.vue?vue&type=script&lang=js"
export * from "./FormCheckboxInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports